import {
  Component,
  OnInit,
  HostListener,
  ViewChild,
  ElementRef,
  OnDestroy,
} from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ChangeDetectorRef } from '@angular/core';
import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface UseCase {
  code: string;
  name: string;
  description: string;
  post_approval_required?: boolean;
}

@Component({
  selector: 'app-onboarding-form',
  templateUrl: './onboarding-form.component.html',
  styleUrls: ['./onboarding-form.component.scss'],
})
export class OnboardingFormComponent implements OnInit, OnDestroy {
  @ViewChild('formContent') formContent: ElementRef;

  currentStep: number = 1;
  totalSteps: number = 8;
  isLoading: boolean = false;
  customerId: string = localStorage.getItem('leadId') || '';

  countries: { name: string; code: string; prefix: string }[] = [
    { name: 'Afghanistan', code: 'AF', prefix: '+93' },
    { name: 'Albania', code: 'AL', prefix: '+355' },
    { name: 'Algeria', code: 'DZ', prefix: '+213' },
    { name: 'American Samoa', code: 'AS', prefix: '+1' },
    { name: 'Andorra', code: 'AD', prefix: '+376' },
    { name: 'Angola', code: 'AO', prefix: '+244' },
    { name: 'Anguilla', code: 'AI', prefix: '+1' },
    { name: 'Antarctica', code: 'AQ', prefix: '+672' },
    { name: 'Antigua and Barbuda', code: 'AG', prefix: '+1' },
    { name: 'Argentina', code: 'AR', prefix: '+54' },
    { name: 'Armenia', code: 'AM', prefix: '+374' },
    { name: 'Aruba', code: 'AW', prefix: '+297' },
    { name: 'Australia', code: 'AU', prefix: '+61' },
    { name: 'Austria', code: 'AT', prefix: '+43' },
    { name: 'Azerbaijan', code: 'AZ', prefix: '+994' },
    { name: 'Bahamas', code: 'BS', prefix: '+1' },
    { name: 'Bahrain', code: 'BH', prefix: '+973' },
    { name: 'Bangladesh', code: 'BD', prefix: '+880' },
    { name: 'Barbados', code: 'BB', prefix: '+1' },
    { name: 'Belarus', code: 'BY', prefix: '+375' },
    { name: 'Belgium', code: 'BE', prefix: '+32' },
    { name: 'Belize', code: 'BZ', prefix: '+501' },
    { name: 'Benin', code: 'BJ', prefix: '+229' },
    { name: 'Bermuda', code: 'BM', prefix: '+1' },
    { name: 'Bhutan', code: 'BT', prefix: '+975' },
    { name: 'Bolivia', code: 'BO', prefix: '+591' },
    { name: 'Bonaire, Sint Eustatius and Saba', code: 'BQ', prefix: '+599' },
    { name: 'Bosnia and Herzegovina', code: 'BA', prefix: '+387' },
    { name: 'Botswana', code: 'BW', prefix: '+267' },
    { name: 'Bouvet Island', code: 'BV', prefix: '+47' },
    { name: 'Brazil', code: 'BR', prefix: '+55' },
    { name: 'British Indian Ocean Territory', code: 'IO', prefix: '+246' },
    { name: 'Brunei Darussalam', code: 'BN', prefix: '+673' },
    { name: 'Bulgaria', code: 'BG', prefix: '+359' },
    { name: 'Burkina Faso', code: 'BF', prefix: '+226' },
    { name: 'Burundi', code: 'BI', prefix: '+257' },
    { name: 'Cabo Verde', code: 'CV', prefix: '+238' },
    { name: 'Cambodia', code: 'KH', prefix: '+855' },
    { name: 'Cameroon', code: 'CM', prefix: '+237' },
    { name: 'Canada', code: 'CA', prefix: '+1' },
    { name: 'Cayman Islands', code: 'KY', prefix: '+1' },
    { name: 'Central African Republic', code: 'CF', prefix: '+236' },
    { name: 'Chad', code: 'TD', prefix: '+235' },
    { name: 'Chile', code: 'CL', prefix: '+56' },
    { name: 'China', code: 'CN', prefix: '+86' },
    { name: 'Christmas Island', code: 'CX', prefix: '+61' },
    { name: 'Cocos (Keeling) Islands', code: 'CC', prefix: '+61' },
    { name: 'Colombia', code: 'CO', prefix: '+57' },
    { name: 'Comoros', code: 'KM', prefix: '+269' },
    { name: 'Congo', code: 'CG', prefix: '+242' },
    {
      name: 'Congo, The Democratic Republic of the',
      code: 'CD',
      prefix: '+243',
    },
    { name: 'Cook Islands', code: 'CK', prefix: '+682' },
    { name: 'Costa Rica', code: 'CR', prefix: '+506' },
    { name: 'Croatia', code: 'HR', prefix: '+385' },
    { name: 'Cuba', code: 'CU', prefix: '+53' },
    { name: 'Curaçao', code: 'CW', prefix: '+599' },
    { name: 'Cyprus', code: 'CY', prefix: '+357' },
    { name: 'Czechia', code: 'CZ', prefix: '+420' },
    { name: "Côte d'Ivoire", code: 'CI', prefix: '+225' },
    { name: 'Denmark', code: 'DK', prefix: '+45' },
    { name: 'Djibouti', code: 'DJ', prefix: '+253' },
    { name: 'Dominica', code: 'DM', prefix: '+1' },
    { name: 'Dominican Republic', code: 'DO', prefix: '+1' },
    { name: 'Ecuador', code: 'EC', prefix: '+593' },
    { name: 'Egypt', code: 'EG', prefix: '+20' },
    { name: 'El Salvador', code: 'SV', prefix: '+503' },
    { name: 'Equatorial Guinea', code: 'GQ', prefix: '+240' },
    { name: 'Eritrea', code: 'ER', prefix: '+291' },
    { name: 'Estonia', code: 'EE', prefix: '+372' },
    { name: 'Eswatini', code: 'SZ', prefix: '+268' },
    { name: 'Ethiopia', code: 'ET', prefix: '+251' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK', prefix: '+500' },
    { name: 'Faroe Islands', code: 'FO', prefix: '+298' },
    { name: 'Fiji', code: 'FJ', prefix: '+679' },
    { name: 'Finland', code: 'FI', prefix: '+358' },
    { name: 'France', code: 'FR', prefix: '+33' },
    { name: 'French Guiana', code: 'GF', prefix: '+594' },
    { name: 'French Polynesia', code: 'PF', prefix: '+689' },
    { name: 'French Southern Territories', code: 'TF', prefix: '+262' },
    { name: 'Gabon', code: 'GA', prefix: '+241' },
    { name: 'Gambia', code: 'GM', prefix: '+220' },
    { name: 'Georgia', code: 'GE', prefix: '+995' },
    { name: 'Germany', code: 'DE', prefix: '+49' },
    { name: 'Ghana', code: 'GH', prefix: '+233' },
    { name: 'Gibraltar', code: 'GI', prefix: '+350' },
    { name: 'Greece', code: 'GR', prefix: '+30' },
    { name: 'Greenland', code: 'GL', prefix: '+299' },
    { name: 'Grenada', code: 'GD', prefix: '+1' },
    { name: 'Guadeloupe', code: 'GP', prefix: '+590' },
    { name: 'Guam', code: 'GU', prefix: '+1' },
    { name: 'Guatemala', code: 'GT', prefix: '+502' },
    { name: 'Guernsey', code: 'GG', prefix: '+44' },
    { name: 'Guinea', code: 'GN', prefix: '+224' },
    { name: 'Guinea-Bissau', code: 'GW', prefix: '+245' },
    { name: 'Guyana', code: 'GY', prefix: '+592' },
    { name: 'Haiti', code: 'HT', prefix: '+509' },
    { name: 'Heard Island and McDonald Islands', code: 'HM', prefix: '+672' },
    { name: 'Holy See (Vatican City State)', code: 'VA', prefix: '+39' },
    { name: 'Honduras', code: 'HN', prefix: '+504' },
    { name: 'Hong Kong', code: 'HK', prefix: '+852' },
    { name: 'Hungary', code: 'HU', prefix: '+36' },
    { name: 'Iceland', code: 'IS', prefix: '+354' },
    { name: 'India', code: 'IN', prefix: '+91' },
    { name: 'Indonesia', code: 'ID', prefix: '+62' },
    { name: 'Iran', code: 'IR', prefix: '+98' },
    { name: 'Iraq', code: 'IQ', prefix: '+964' },
    { name: 'Ireland', code: 'IE', prefix: '+353' },
    { name: 'Isle of Man', code: 'IM', prefix: '+44' },
    { name: 'Israel', code: 'IL', prefix: '+972' },
    { name: 'Italy', code: 'IT', prefix: '+39' },
    { name: 'Jamaica', code: 'JM', prefix: '+1' },
    { name: 'Japan', code: 'JP', prefix: '+81' },
    { name: 'Jersey', code: 'JE', prefix: '+44' },
    { name: 'Jordan', code: 'JO', prefix: '+962' },
    { name: 'Kazakhstan', code: 'KZ', prefix: '+7' },
    { name: 'Kenya', code: 'KE', prefix: '+254' },
    { name: 'Kiribati', code: 'KI', prefix: '+686' },
    { name: 'Kosovo', code: 'XK', prefix: '+383' },
    { name: 'Kuwait', code: 'KW', prefix: '+965' },
    { name: 'Kyrgyzstan', code: 'KG', prefix: '+996' },
    { name: "Lao People's Democratic Republic", code: 'LA', prefix: '+856' },
    { name: 'Latvia', code: 'LV', prefix: '+371' },
    { name: 'Lebanon', code: 'LB', prefix: '+961' },
    { name: 'Lesotho', code: 'LS', prefix: '+266' },
    { name: 'Liberia', code: 'LR', prefix: '+231' },
    { name: 'Libya', code: 'LY', prefix: '+218' },
    { name: 'Liechtenstein', code: 'LI', prefix: '+423' },
    { name: 'Lithuania', code: 'LT', prefix: '+370' },
    { name: 'Luxembourg', code: 'LU', prefix: '+352' },
    { name: 'Macao', code: 'MO', prefix: '+853' },
    { name: 'Madagascar', code: 'MG', prefix: '+261' },
    { name: 'Malawi', code: 'MW', prefix: '+265' },
    { name: 'Malaysia', code: 'MY', prefix: '+60' },
    { name: 'Maldives', code: 'MV', prefix: '+960' },
    { name: 'Mali', code: 'ML', prefix: '+223' },
    { name: 'Malta', code: 'MT', prefix: '+356' },
    { name: 'Marshall Islands', code: 'MH', prefix: '+692' },
    { name: 'Martinique', code: 'MQ', prefix: '+596' },
    { name: 'Mauritania', code: 'MR', prefix: '+222' },
    { name: 'Mauritius', code: 'MU', prefix: '+230' },
    { name: 'Mayotte', code: 'YT', prefix: '+262' },
    { name: 'Mexico', code: 'MX', prefix: '+52' },
    { name: 'Micronesia, Federated States of', code: 'FM', prefix: '+691' },
    { name: 'Moldova', code: 'MD', prefix: '+373' },
    { name: 'Monaco', code: 'MC', prefix: '+377' },
    { name: 'Mongolia', code: 'MN', prefix: '+976' },
    { name: 'Montenegro', code: 'ME', prefix: '+382' },
    { name: 'Montserrat', code: 'MS', prefix: '+1' },
    { name: 'Morocco', code: 'MA', prefix: '+212' },
    { name: 'Mozambique', code: 'MZ', prefix: '+258' },
    { name: 'Myanmar', code: 'MM', prefix: '+95' },
    { name: 'Namibia', code: 'NA', prefix: '+264' },
    { name: 'Nauru', code: 'NR', prefix: '+674' },
    { name: 'Nepal', code: 'NP', prefix: '+977' },
    { name: 'Netherlands', code: 'NL', prefix: '+31' },
    { name: 'New Caledonia', code: 'NC', prefix: '+687' },
    { name: 'New Zealand', code: 'NZ', prefix: '+64' },
    { name: 'Nicaragua', code: 'NI', prefix: '+505' },
    { name: 'Niger', code: 'NE', prefix: '+227' },
    { name: 'Nigeria', code: 'NG', prefix: '+234' },
    { name: 'Niue', code: 'NU', prefix: '+683' },
    { name: 'Norfolk Island', code: 'NF', prefix: '+672' },
    { name: 'North Korea', code: 'KP', prefix: '+850' },
    { name: 'North Macedonia', code: 'MK', prefix: '+389' },
    { name: 'Northern Mariana Islands', code: 'MP', prefix: '+1' },
    { name: 'Norway', code: 'NO', prefix: '+47' },
    { name: 'Oman', code: 'OM', prefix: '+968' },
    { name: 'Pakistan', code: 'PK', prefix: '+92' },
    { name: 'Palau', code: 'PW', prefix: '+680' },
    { name: 'Palestine, State of', code: 'PS', prefix: '+970' },
    { name: 'Panama', code: 'PA', prefix: '+507' },
    { name: 'Papua New Guinea', code: 'PG', prefix: '+675' },
    { name: 'Paraguay', code: 'PY', prefix: '+595' },
    { name: 'Peru', code: 'PE', prefix: '+51' },
    { name: 'Philippines', code: 'PH', prefix: '+63' },
    { name: 'Pitcairn', code: 'PN', prefix: '+64' },
    { name: 'Poland', code: 'PL', prefix: '+48' },
    { name: 'Portugal', code: 'PT', prefix: '+351' },
    { name: 'Puerto Rico', code: 'PR', prefix: '+1' },
    { name: 'Qatar', code: 'QA', prefix: '+974' },
    { name: 'Romania', code: 'RO', prefix: '+40' },
    { name: 'Russian Federation', code: 'RU', prefix: '+7' },
    { name: 'Rwanda', code: 'RW', prefix: '+250' },
    { name: 'Réunion', code: 'RE', prefix: '+262' },
    { name: 'Saint Barthélemy', code: 'BL', prefix: '+590' },
    {
      name: 'Saint Helena, Ascension and Tristan da Cunha',
      code: 'SH',
      prefix: '+290',
    },
    { name: 'Saint Kitts and Nevis', code: 'KN', prefix: '+1' },
    { name: 'Saint Lucia', code: 'LC', prefix: '+1' },
    { name: 'Saint Martin (French part)', code: 'MF', prefix: '+590' },
    { name: 'Saint Pierre and Miquelon', code: 'PM', prefix: '+508' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC', prefix: '+1' },
    { name: 'Samoa', code: 'WS', prefix: '+685' },
    { name: 'San Marino', code: 'SM', prefix: '+378' },
    { name: 'South Korea', code: 'KR', prefix: '+82' },
    { name: 'South Sudan', code: 'SS', prefix: '+211' },
    { name: 'Spain', code: 'ES', prefix: '+34' },
    { name: 'Sri Lanka', code: 'LK', prefix: '+94' },
    { name: 'Sudan', code: 'SD', prefix: '+249' },
    { name: 'Suriname', code: 'SR', prefix: '+597' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ', prefix: '+47' },
    { name: 'Sweden', code: 'SE', prefix: '+46' },
    { name: 'Switzerland', code: 'CH', prefix: '+41' },
    { name: 'Syrian Arab Republic', code: 'SY', prefix: '+963' },
    { name: 'Taiwan', code: 'TW', prefix: '+886' },
    { name: 'Tajikistan', code: 'TJ', prefix: '+992' },
    { name: 'Tanzania', code: 'TZ', prefix: '+255' },
    { name: 'Thailand', code: 'TH', prefix: '+66' },
    { name: 'Timor-Leste', code: 'TL', prefix: '+670' },
    { name: 'Togo', code: 'TG', prefix: '+228' },
    { name: 'Tokelau', code: 'TK', prefix: '+690' },
    { name: 'Tonga', code: 'TO', prefix: '+676' },
    { name: 'Trinidad and Tobago', code: 'TT', prefix: '+1' },
    { name: 'Tunisia', code: 'TN', prefix: '+216' },
    { name: 'Turkmenistan', code: 'TM', prefix: '+993' },
    { name: 'Turks and Caicos Islands', code: 'TC', prefix: '+1' },
    { name: 'Tuvalu', code: 'TV', prefix: '+688' },
    { name: 'Uganda', code: 'UG', prefix: '+256' },
    { name: 'Ukraine', code: 'UA', prefix: '+380' },
    { name: 'United Arab Emirates', code: 'AE', prefix: '+971' },
    { name: 'United Kingdom', code: 'GB', prefix: '+44' },
    { name: 'United States', code: 'US', prefix: '+1' },
    { name: 'United States Minor Outlying Islands', code: 'UM', prefix: '+1' },
    { name: 'Uruguay', code: 'UY', prefix: '+598' },
    { name: 'Uzbekistan', code: 'UZ', prefix: '+998' },
    { name: 'Vanuatu', code: 'VU', prefix: '+678' },
    { name: 'Venezuela', code: 'VE', prefix: '+58' },
    { name: 'Vietnam', code: 'VN', prefix: '+84' },
    { name: 'Virgin Islands, British', code: 'VG', prefix: '+1' },
    { name: 'Virgin Islands, U.S.', code: 'VI', prefix: '+1' },
    { name: 'Wallis and Futuna', code: 'WF', prefix: '+681' },
    { name: 'Western Sahara', code: 'EH', prefix: '+212' },
    { name: 'Yemen', code: 'YE', prefix: '+967' },
    { name: 'Zambia', code: 'ZM', prefix: '+260' },
    { name: 'Zimbabwe', code: 'ZW', prefix: '+263' },
    { name: 'Åland Islands', code: 'AX', prefix: '+358' },
  ];

  useCases: UseCase[] = [];
  selectedUseCase: string = '';
  campaignDescription: string = '';
  messageSamples: string[] = ['', ''];
  messageFlow: string = '';
  hasEmbeddedLinks: boolean = false;
  hasEmbeddedPhone: boolean = false;
  nextButtonPressed: boolean = false;

  errors: { [key: string]: string } = {};

  legalBusinessName: string = '';
  profileFriendlyName: string = '';
  country: string = '';
  street1: string = '';
  street2: string = '';
  city: string = '';
  state: string = '';
  postalCode: string = '';
  businessIdentity: string = 'direct_customer';
  businessType: string = '';
  businessIndustry: string = '';
  registrationIdType: string = '';

  businessIndustries: string[] = [
    'AGRICULTURE',
    'AUTOMOTIVE',
    'BANKING',
    'CONSTRUCTION',
    'CONSUMER',
    'EDUCATION',
    'ELECTRONICS',
    'ENGINEERING',
    'ENERGY',
    'FAST_MOVING_CONSUMER_GOODS',
    'FINANCIAL',
    'FINTECH',
    'FOOD_AND_BEVERAGE',
    'GOVERNMENT',
    'HEALTHCARE',
    'HOSPITALITY',
    'INSURANCE',
    'JEWELRY',
    'LEGAL',
    'MANUFACTURING',
    'MEDIA',
    'NOT_FOR_PROFIT',
    'OIL_AND_GAS',
    'ONLINE',
    'PROFESSIONAL_SERVICES',
    'RAW_MATERIALS',
    'REAL_ESTATE',
    'RELIGION',
    'RETAIL',
    'TECHNOLOGY',
    'TELECOMMUNICATIONS',
    'TRANSPORTATION',
    'TRAVEL',
  ];

  idTypes = [
    { code: 'US:EIN', name: 'USA: Employer Identification Number (EIN)' },
    { code: 'US:DUNS', name: 'USA: Dun & Bradstreet Number (DUNS)' },
    { code: 'CA:CBN', name: 'Canada: Canadian Business Number (CBN)' },
    { code: 'GB:CN', name: 'Great Britain: Company Number (CN)' },
    { code: 'AU:ACN', name: 'Australia: Australian Company Number (ACN)' },
    { code: 'IN:CIN', name: 'India: Corporate Identity Number (CIN)' },
    { code: 'EE:VAT', name: 'Estonia: VAT Number' },
    { code: 'RO:VATRN', name: 'Romania: VAT Registration Number (VATRN)' },
    { code: 'IL:RN', name: 'Israel: Registration Number (RN)' },
    { code: 'Other', name: 'Other' },
  ];

  registrationNumber: string = '';
  regions: { [key: string]: boolean } = {
    africa: false,
    asia: false,
    australia: false,
    europe: false,
    latinAmerica: false,
    usaCanada: true,
  };
  businessWebsite: string = '';
  repFirstName: string = '';
  repLastName: string = '';
  repEmail: string = '';
  selectedPhoneCountry: { name: string; code: string; prefix: string } =
    this.countries.find((country) => country.code === 'US')!;
  repPhone: string = '';
  businessTitle: string = '';
  repJobPosition: string = '';
  notificationEmail: string = '';
  acceptTerms: boolean = true;
  messagingFriendlyName: string = '';
  inboundRequestUrl: string = '';
  fallbackUrl: string = '';
  brandEmail: string = '';

  brandStatus: string = '';
  rejectionReason: string = '';

  private wsSubject: WebSocketSubject<any>;
  private destroy$ = new Subject<void>();

  constructor(
    private api: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit() {
    if (!this.customerId) {
      this.router.navigate(['/onboarding']);
      return;
    }

    const savedBrandStatus = localStorage.getItem('brandStatus');
    const savedRejectionReason = localStorage.getItem('rejectionReason');
    if (savedBrandStatus) {
      this.brandStatus = savedBrandStatus;
      this.rejectionReason = savedRejectionReason || '';
    }

    this.route.queryParams.subscribe((params) => {
      const step = parseInt(params['step'], 10);
      if (step && step >= 1 && step <= this.totalSteps) {
        this.currentStep = step;
        if (
          this.currentStep === 7 &&
          this.brandStatus !== 'registration_failed'
        ) {
          this.fetchUseCases();
        }
      }
    });

    this.selectedPhoneCountry = this.countries.find(
      (country) => country.code === 'US'
    )!;

    this.checkOnboardingStatus();
    this.connectWebSocket();
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.wsSubject) {
      this.wsSubject.complete();
    }
  }

  updateMessageSample(index: number, value: string): void {
    // Create a new array to trigger change detection
    this.messageSamples = [...this.messageSamples];
    this.messageSamples[index] = value;
  }

  trackByIndex(index: number, item: any): number {
    return index;
  }

  fetchUseCases(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.isLoading = true;
      console.log('[fetchUseCases] Starting fetch for use cases...');
      if (this.brandStatus === 'approved' || this.brandStatus === 'pending') {
        this.api.getUseCases(this.customerId).subscribe({
          next: (res: any) => {
            this.isLoading = false;
            console.log('[fetchUseCases] Response:', res);

            if (res.use_cases) {
              this.useCases = res.use_cases;
              this.brandStatus = 'approved';
              console.log('[fetchUseCases] Loaded useCases:', this.useCases);

              if (this.selectedUseCase && this.useCases.length > 0) {
                console.log(
                  '[fetchUseCases] Checking if selectedUseCase is valid:',
                  this.selectedUseCase
                );
                const isValid = this.useCases.some(
                  (uc) => uc.code === this.selectedUseCase
                );
                if (!isValid) {
                  console.warn(
                    '[fetchUseCases] Invalid selectedUseCase. Resetting it.'
                  );
                  this.snackBar.open(
                    'Previously selected use case is no longer available.',
                    'Close',
                    { duration: 3000 }
                  );
                  this.selectedUseCase = '';
                } else {
                  console.log('[fetchUseCases] selectedUseCase is valid.');
                }
              }
            } else {
              this.useCases = [];
              console.warn('[fetchUseCases] No use_cases returned from API.');
            }

            this.cdr.detectChanges();
            resolve();
          },
          error: (err) => {
            this.isLoading = false;
            console.error('[fetchUseCases] Failed to fetch use cases:', err);
            this.snackBar.open(
              'Failed to fetch use cases. Please try again.',
              'Close',
              { duration: 2000 }
            );
            reject(err);
          },
        });
      }
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  unloadHandler(event: Event) {
    this.saveFormData();
  }

  connectWebSocket() {
    // Check if customerId is present
    if (!this.customerId) {
      console.error('[WebSocket] Customer ID is missing');
      return;
    }

    // Construct and log the WebSocket URL
    const wsUrl = `wss://whatnow-staging.herokuapp.com/api/onboarding/v1/ws?customer_id=${this.customerId}`;
    // const wsUrl = `ws://localhost:3000/api/onboarding/v1/ws?customer_id=${this.customerId}`;
    console.log(`[WebSocket] Attempting to connect to URL: ${wsUrl}`);

    // Wrap WebSocket setup in a try-catch to catch unexpected errors
    try {
      this.wsSubject = webSocket({
        url: wsUrl,
        openObserver: {
          next: () => {
            console.log('[WebSocket] ✅ Connection opened successfully');
          },
        },
        closeObserver: {
          next: (closeEvent) => {
            console.warn('[WebSocket] ❌ Connection closed', closeEvent);
            console.log(
              '[WebSocket] Close event details:',
              JSON.stringify(closeEvent)
            );
          },
        },
      });

      this.wsSubject.pipe(takeUntil(this.destroy$)).subscribe({
        next: (msg) => {
          console.log('[WebSocket] 📩 Message received:', msg);
          this.handleWebSocketMessage(msg);
        },
        error: (err) => {
          console.error('[WebSocket] 🚨 Connection failed or dropped:', err);
          console.log('[WebSocket] Error details:', JSON.stringify(err));
          this.snackBar.open('Lost connection. Retrying...', 'Close', {
            duration: 2000,
          });
          setTimeout(() => {
            console.log('[WebSocket] 🔄 Retrying connection in 5 seconds...');
            this.connectWebSocket();
          }, 5000);
        },
        complete: () => {
          console.log('[WebSocket] ✅ Connection completed/closed gracefully');
        },
      });
    } catch (error) {
      console.error(
        '[WebSocket] ❗ Unexpected exception during WebSocket setup:',
        error
      );
      console.log('[WebSocket] Exception details:', JSON.stringify(error));
    }
  }

  handleWebSocketMessage(msg: any) {
    console.log('Received WebSocket message:', msg);

    if (msg.brand_registration_status) {
      this.brandStatus = msg.brand_registration_status;
      this.rejectionReason = msg.rejection_reason || 'Unknown reason';
      // Save to localStorage
      localStorage.setItem('brandStatus', this.brandStatus);
      localStorage.setItem('rejectionReason', this.rejectionReason);
      if (this.brandStatus === 'registration_failed') {
        this.isLoading = false;
        this.snackBar.open(
          'Brand registration failed. Please check details.',
          'Close',
          { duration: 5000 }
        );
      }
      console.log('brand status handle websocket: ', this.brandStatus);

      // if (msg.campaign_registration_status === 'pending') {
      //   this.isLoading = false;
      //   this.snackBar.open('Brand registered successfully.', 'Close', {
      //     duration: 3000,
      //   });
      //   localStorage.removeItem('brandStatus');
      //   localStorage.removeItem('rejectionReason');
      //   // this.router.navigate(['/onboarding/status']);
      // }
    }

    if (msg.current_step) {
      if (
        msg.current_step === 'pending_use_case_selection' &&
        msg.available_use_cases_json
      ) {
        this.useCases = JSON.parse(msg.available_use_cases_json);
        this.isLoading = false;
        if (this.brandStatus !== 'registration_failed') {
          this.brandStatus = msg.brand_registration_status || 'approved';
          localStorage.setItem('brandStatus', this.brandStatus);
        }
        if (this.currentStep < 7) {
          this.currentStep = 7;
          this.snackBar.open('Use cases available for selection.', 'Close', {
            duration: 2000,
          });
        }
      } else if (msg.current_step === 'awaiting_brand_approval') {
        this.isLoading = true;
      } else if (msg.current_step === 'use_case_selected') {
        this.isLoading = false;
        this.snackBar.open('Use case selected. Check status.', 'Close', {
          duration: 3000,
        });
        localStorage.removeItem('brandStatus');
        localStorage.removeItem('rejectionReason');
        this.router.navigate(['/onboarding/status']);
      } else if (msg.current_step === 'campaign_registered') {
        this.isLoading = false;
        this.snackBar.open('Campaign registered successfully.', 'Close', {
          duration: 3000,
        });
        localStorage.removeItem('brandStatus');
        localStorage.removeItem('rejectionReason');
        this.router.navigate(['/onboarding/status']);
      }
    }

    this.cdr.detectChanges();
  }
  reloginAndRedirect() {
    if (this.customerId) {
      this.api.clearFormData(this.customerId).subscribe({
        next: () => {
          console.log('Form data cleared successfully');
          localStorage.removeItem('leadId');
          localStorage.removeItem('brandStatus');
          localStorage.removeItem('rejectionReason');
          window.location.href = 'https://whatnow.group/sign-up/';
        },
        error: (err) => {
          console.error('Error clearing form data:', err);
          localStorage.removeItem('brandStatus');
          localStorage.removeItem('rejectionReason');
          // Proceed with redirection even if clearing fails
          window.location.href = 'https://whatnow.group/sign-up/';
        },
      });
    } else {
      console.warn('No customerId available, skipping form data clear');
      window.location.href = 'https://whatnow.group/sign-up/';
    }
  }

  getMessageSamplePlaceholder(index: number): string {
    return `Message Sample ${
      index + 1
    } (e.g., "Welcome to our service! Reply STOP to opt-out.")`;
  }

  addMessageSample() {
    if (this.messageSamples.length < 5) {
      // Create a new array to ensure proper change detection
      this.messageSamples = [...this.messageSamples, ''];
      this.errors[`messageSamples${this.messageSamples.length - 1}`] = '';
    }
  }

  removeMessageSample(index: number) {
    if (this.messageSamples.length > 2) {
      // Create a new array to ensure proper change detection
      this.messageSamples = this.messageSamples.filter((_, i) => i !== index);

      // Clean up error messages
      delete this.errors[`messageSamples${index}`];
      for (let i = index; i < this.messageSamples.length; i++) {
        this.errors[`messageSamples${i}`] =
          this.errors[`messageSamples${i + 1}`] || '';
        delete this.errors[`messageSamples${i + 1}`];
      }
    }
  }

  saveDraft() {
    this.saveFormData();
    this.snackBar.open('Your progress has been saved.', 'Close', {
      duration: 2000,
    });
  }

  loadDraftData() {
    this.isLoading = true;
    console.log('[loadDraftData] Fetching draft data...');
    this.api.getFormData(this.customerId).subscribe({
      next: (res: any) => {
        this.isLoading = false;
        console.log('[loadDraftData] Draft data response:', res);

        if (res.form_step && res.form_data) {
          // if (res.form_data.brand_status) {
          //   this.brandStatus = res.form_data.brand_status;
          //   this.rejectionReason = res.form_data.rejection_reason || '';
          // }

          // Use the saved step from the database
          this.currentStep = res.form_step;
          const formData = res.form_data;
          const savedUseCase =
            formData.campaign_configuration?.selected_use_case;
          console.log('[loadDraftData] savedUseCase from draft:', savedUseCase);

          this.assignFormData(formData);
          console.log('[loadDraftData] Form data assigned:', formData);
          this.cdr.detectChanges();

          if (
            this.currentStep === 7 &&
            (this.brandStatus === 'approved' || this.brandStatus === 'pending')
          ) {
            this.fetchUseCases()
              .then(() => {
                console.log(
                  '[loadDraftData] After fetchUseCases, useCases:',
                  this.useCases
                );
                if (savedUseCase && this.useCases.length > 0) {
                  const isValidUseCase = this.useCases.some(
                    (uc) => uc.code === savedUseCase
                  );
                  console.log(
                    '[loadDraftData] Is savedUseCase valid?',
                    isValidUseCase
                  );

                  if (isValidUseCase) {
                    this.selectedUseCase = savedUseCase;
                    console.log(
                      '[loadDraftData] Restored saved use case:',
                      this.selectedUseCase
                    );
                    this.cdr.detectChanges();
                  } else {
                    console.warn(
                      '[loadDraftData] Saved use case not found in current useCases list.'
                    );
                  }
                }
                this.cdr.detectChanges();
              })
              .catch((err) => {
                console.error('[loadDraftData] Error fetching use cases:', err);
                this.snackBar.open(
                  'Failed to fetch use cases. Please try again.',
                  'Close',
                  { duration: 2000 }
                );
              });
          }
        } else {
          // Default to step 1 if no saved data exists
          this.currentStep = 1;
          console.log(
            '[loadDraftData] No saved data found, starting at step 1'
          );
        }
      },
      error: (err) => {
        this.isLoading = false;
        console.error('[loadDraftData] Failed to load draft data:', err);
        this.snackBar.open(
          'Failed to load draft data. Starting fresh.',
          'Close',
          {
            duration: 2000,
          }
        );
        this.currentStep = 1; // Default to step 1 on error
      },
    });
  }

  assignFormData(formData: any) {
    if (formData.general_information) {
      this.legalBusinessName =
        formData.general_information.legal_business_name ||
        this.legalBusinessName;
      this.profileFriendlyName =
        formData.general_information.profile_friendly_name ||
        this.profileFriendlyName;
      this.country = formData.general_information.country || this.country;
      this.street1 = formData.general_information.street1 || this.street1;
      this.street2 = formData.general_information.street2 || this.street2;
      this.city = formData.general_information.city || this.city;
      this.state = formData.general_information.state || this.state;
      this.postalCode =
        formData.general_information.postal_code || this.postalCode;
    }
    if (formData.business_information) {
      this.businessIdentity =
        formData.business_information.business_identity ||
        this.businessIdentity;
      this.businessType =
        formData.business_information.business_type || this.businessType;
      this.businessIndustry =
        formData.business_information.business_industry ||
        this.businessIndustry;
      this.registrationIdType =
        formData.business_information.registration_id_type ||
        this.registrationIdType;
      this.registrationNumber =
        formData.business_information.registration_number ||
        this.registrationNumber;
      this.businessWebsite =
        formData.business_information.business_website || this.businessWebsite;
      const savedRegions =
        formData.business_information.business_regions_of_operation || [];
      Object.keys(this.regions).forEach((key) => {
        const regionKey = this.mapRegionToBackend(key);
        this.regions[key] = savedRegions.includes(regionKey);
      });
    }
    if (formData.point_of_contact) {
      this.repFirstName =
        formData.point_of_contact.rep_first_name || this.repFirstName;
      this.repLastName =
        formData.point_of_contact.rep_last_name || this.repLastName;
      this.repEmail = formData.point_of_contact.rep_email || this.repEmail;
      const fullPhone = formData.point_of_contact.rep_phone;
      if (fullPhone) {
        let longestMatchingCountry = this.countries.find((c) =>
          fullPhone.startsWith(c.prefix)
        );
        if (longestMatchingCountry) {
          let cleanedNumber = fullPhone;
          // Keep removing the prefix until it no longer starts with it
          while (cleanedNumber.startsWith(longestMatchingCountry.prefix)) {
            cleanedNumber = cleanedNumber.slice(
              longestMatchingCountry.prefix.length
            );
          }
          this.selectedPhoneCountry = longestMatchingCountry;
          this.repPhone = cleanedNumber;
        } else {
          console.warn(
            'Phone number prefix does not match any known country prefix'
          );
          this.selectedPhoneCountry = this.countries.find(
            (c) => c.code === 'US'
          )!; // Default to US
          this.repPhone = fullPhone.replace(/\D/g, ''); // Clean to digits only as a fallback
        }
      }
      this.businessTitle =
        formData.point_of_contact.business_title || this.businessTitle;
      this.repJobPosition =
        formData.point_of_contact.rep_job_position || this.repJobPosition;
    }
    if (formData.notification_settings) {
      this.notificationEmail =
        formData.notification_settings.notification_email ||
        this.notificationEmail;
    }
    if (formData.messaging_service) {
      this.messagingFriendlyName =
        formData.messaging_service.friendly_name || this.messagingFriendlyName;
      this.inboundRequestUrl =
        formData.messaging_service.inbound_request_url ||
        this.inboundRequestUrl;
      this.fallbackUrl =
        formData.messaging_service.fallback_url || this.fallbackUrl;
    }
    if (formData.brand_registration) {
      this.brandEmail =
        formData.brand_registration.brand_email || this.brandEmail;
    }
    if (formData.campaign_configuration) {
      console.log(
        'Populating campaign configuration:',
        formData.campaign_configuration
      );
      // this.selectedUseCase =
      //   formData.campaign_configuration.selected_use_case ||
      //   this.selectedUseCase;
      this.campaignDescription =
        formData.campaign_configuration.campaign_description ||
        this.campaignDescription;
      this.messageSamples =
        formData.campaign_configuration.message_samples || this.messageSamples;
      this.messageFlow =
        formData.campaign_configuration.message_flow || this.messageFlow;
      this.hasEmbeddedLinks =
        formData.campaign_configuration.has_embedded_links ||
        this.hasEmbeddedLinks;
      this.hasEmbeddedPhone =
        formData.campaign_configuration.has_embedded_phone ||
        this.hasEmbeddedPhone;
    }
    if (formData.terms_and_privacy) {
      this.acceptTerms =
        formData.terms_and_privacy.accept_terms || this.acceptTerms;
    }
  }

  getFormDataPayload() {
    const selectedRegions = Object.keys(this.regions)
      .filter((key) => this.regions[key])
      .map((key) => this.mapRegionToBackend(key));

    const payload: any = {
      general_information: {
        legal_business_name: this.legalBusinessName,
        profile_friendly_name: this.profileFriendlyName,
        country: this.country,
        street1: this.street1,
        street2: this.street2,
        city: this.city,
        state: this.state,
        postal_code: this.postalCode,
      },
      business_information: {
        business_identity: this.businessIdentity,
        business_type: this.businessType,
        business_industry: this.businessIndustry,
        registration_id_type: this.registrationIdType,
        registration_number: this.registrationNumber,
        business_regions_of_operation: selectedRegions,
        business_website: this.businessWebsite,
      },
      point_of_contact: {
        rep_first_name: this.repFirstName,
        rep_last_name: this.repLastName,
        rep_email: this.repEmail,
        rep_phone: `${this.selectedPhoneCountry.prefix}${this.repPhone}`,
        business_title: this.businessTitle,
        rep_job_position: this.repJobPosition,
      },
      notification_settings: {
        notification_email: this.notificationEmail,
      },
      messaging_service: {
        friendly_name: this.messagingFriendlyName || undefined,
        inbound_request_url: this.inboundRequestUrl,
        fallback_url: this.fallbackUrl,
      },
      brand_registration: {
        brand_email: this.brandEmail,
      },
      terms_and_privacy: {
        accept_terms: this.acceptTerms,
      },
    };

    if (this.currentStep >= 7) {
      payload.campaign_configuration = {
        selected_use_case: this.selectedUseCase,
        campaign_description: this.campaignDescription,
        message_samples: this.messageSamples,
        message_flow: this.messageFlow,
        has_embedded_links: this.hasEmbeddedLinks,
        has_embedded_phone: this.hasEmbeddedPhone,
      };
    }

    return payload;
  }

  saveFormData() {
    const payload = this.getFormDataPayload();
    console.log('Saving draft with payload:', payload);
    this.api
      .saveFormData(this.customerId, this.currentStep, payload)
      .subscribe({
        next: (res: any) => console.log('Form data saved:', res),
        error: (err) => {
          console.error('Failed to save form data:', err);
          this.snackBar.open(
            'Failed to save progress. Please try again.',
            'Close',
            { duration: 2000 }
          );
        },
      });
  }

  checkOnboardingStatus() {
    this.isLoading = true;
    this.api.getOnboardingStatus(this.customerId).subscribe({
      next: (status: any) => {
        if (status.brand_registration_status) {
          this.brandStatus = status.brand_registration_status;
          this.rejectionReason = status.rejection_reason || '';
          localStorage.setItem('brandStatus', this.brandStatus);
          localStorage.setItem('rejectionReason', this.rejectionReason);
          this.saveFormData();
        }
        if (status.is_completed) {
          this.router.navigate(['/onboarding/status']);
        } else {
          this.loadDraftData();
        }
        this.isLoading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Failed to get onboarding status:', err);
        this.snackBar.open(
          'Error checking status. Please try again.',
          'Close',
          {
            duration: 2000,
          }
        );
        this.loadDraftData();
        this.isLoading = false;
        this.cdr.detectChanges();
      },
    });
  }

  mapRegionToBackend(key: string): string {
    switch (key) {
      case 'africa':
        return 'AFRICA';
      case 'asia':
        return 'ASIA';
      case 'australia':
        return 'AUSTRALIA';
      case 'europe':
        return 'EUROPE';
      case 'latinAmerica':
        return 'LATIN_AMERICA';
      case 'usaCanada':
        return 'USA_AND_CANADA';
      default:
        return '';
    }
  }

  submitUseCase() {
    if (!this.isStepValid()) return;

    const payload = {
      selected_use_case: this.selectedUseCase,
      campaign_description: this.campaignDescription,
      message_samples: this.messageSamples,
      message_flow: this.messageFlow,
      has_embedded_links: this.hasEmbeddedLinks,
      has_embedded_phone: this.hasEmbeddedPhone,
    };

    this.isLoading = true;
    this.api
      .submitSelectedUseCase(this.customerId, this.selectedUseCase, payload)
      .subscribe({
        next: (res) => {
          this.isLoading = false;
          this.snackBar.open(
            'Use case and campaign details submitted successfully!',
            'Close',
            { duration: 2000 }
          );
          this.currentStep++;
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Error submitting use case:', err);
          this.snackBar.open(
            'Failed to submit use case. Please try again.',
            'Close',
            { duration: 2000 }
          );
        },
      });
  }

  proceedToNextStep() {
    this.nextButtonPressed = true;
    if (this.isStepValid()) {
      this.nextButtonPressed = false;
      this.errors = {};
      this.saveFormData();
      if (this.currentStep === 6) {
        this.currentStep = 7;
        this.saveFormData();
        this.submitBrandRegistration();
      } else if (this.currentStep === 7 && this.useCases.length) {
        this.saveFormData();
        this.submitUseCase();
      } else {
        this.currentStep++;
        this.saveFormData();
        if (this.currentStep === 7) {
          this.isLoading = true;
        }
        this.scrollToTop();
      }
    } else {
      this.cdr.detectChanges();
    }
  }

  submitBrandRegistration() {
    const payload = this.getFormDataPayload();
    this.isLoading = true;
    this.brandStatus = 'pending';
    this.api.submitOnboardingData(this.customerId, payload).subscribe({
      next: (res) => {
        this.isLoading = false;
        this.snackBar.open(
          'Brand registration submitted. Awaiting approval.',
          'Close',
          { duration: 2000 }
        );
        this.currentStep = 7;
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Failed to submit brand registration:', err);
        this.snackBar.open(
          'Failed to submit brand registration. Please try again.',
          'Close',
          { duration: 2000 }
        );
      },
    });
  }

  goBack() {
    if (this.currentStep > 1) {
      this.saveFormData();
      this.currentStep--;
      this.nextButtonPressed = false;
      this.errors = {};
      this.scrollToTop();
    }
  }

  scrollToTop() {
    if (this.formContent && this.formContent.nativeElement) {
      this.formContent.nativeElement.scrollTop = 0;
    }
  }

  submitOnboarding() {
    this.nextButtonPressed = true;
    if (!this.isStepValid()) return;

    // this.isLoading = true;
    this.router.navigate(['/onboarding/status']);
  }

  isNavigationDisabled(): boolean {
    return (
      (this.currentStep === 7 &&
        (this.isLoading || this.useCases.length === 0)) ||
      this.currentStep === 8
    );
  }
  isStepValid(): boolean {
    this.errors = {};
    let isValid = true;

    switch (this.currentStep) {
      case 1:
        if (!this.legalBusinessName)
          this.errors['legalBusinessName'] = 'This field is required';
        if (!this.profileFriendlyName)
          this.errors['profileFriendlyName'] = 'This field is required';
        if (!this.country) this.errors['country'] = 'This field is required';
        if (!this.street1) this.errors['street1'] = 'This field is required';
        if (!this.city) this.errors['city'] = 'This field is required';
        if (!this.state) this.errors['state'] = 'This field is required';
        if (!this.postalCode)
          this.errors['postalCode'] = 'This field is required';
        isValid = Object.keys(this.errors).length === 0;
        break;
      case 2:
        if (!this.businessType)
          this.errors['businessType'] = 'This field is required';
        if (!this.businessIndustry)
          this.errors['businessIndustry'] = 'This field is required';
        if (!this.registrationIdType)
          this.errors['registrationIdType'] = 'This field is required';
        if (!this.registrationNumber) {
          this.errors['registrationNumber'] = 'This field is required';
        } else {
          const formatRegex = formatRules[this.registrationIdType];
          if (formatRegex && !formatRegex.test(this.registrationNumber)) {
            this.errors['registrationNumber'] = `Invalid format for ${
              this.registrationIdType
            }. Expected format: ${this.getFormatExample(
              this.registrationIdType
            )}`;
          }
        }
        if (!this.businessWebsite)
          this.errors['businessWebsite'] = 'This field is required';
        if (!Object.values(this.regions).some((region) => region))
          this.errors['regions'] = 'At least one region is required';
        isValid = Object.keys(this.errors).length === 0;
        break;
      case 3:
        if (!this.repFirstName)
          this.errors['repFirstName'] = 'This field is required';
        if (!this.repLastName)
          this.errors['repLastName'] = 'This field is required';
        if (!this.repEmail) this.errors['repEmail'] = 'This field is required';
        if (!this.repPhone) {
          this.errors['repPhone'] = 'This field is required';
        } else {
          const cleanNumber = this.repPhone.replace(/\D/g, '');
          if (!/^\d+$/.test(cleanNumber)) {
            this.errors['repPhone'] = 'Phone number must contain only digits';
          }
          this.repPhone = cleanNumber;
        }
        if (!this.businessTitle)
          this.errors['businessTitle'] = 'This field is required';
        if (!this.repJobPosition)
          this.errors['repJobPosition'] = 'This field is required';
        isValid = Object.keys(this.errors).length === 0;
        break;
      case 4:
        if (!this.notificationEmail)
          this.errors['notificationEmail'] = 'This field is required';
        isValid = Object.keys(this.errors).length === 0;
        break;
      case 5:
        if (!this.inboundRequestUrl)
          this.errors['inboundRequestUrl'] = 'This field is required';
        if (!this.fallbackUrl)
          this.errors['fallbackUrl'] = 'This field is required';
        isValid = Object.keys(this.errors).length === 0;
        break;
      case 6:
        if (!this.brandEmail)
          this.errors['brandEmail'] = 'This field is required';
        isValid = Object.keys(this.errors).length === 0;
        break;
      case 7:
        if (this.useCases.length === 0) return true;
        if (!this.selectedUseCase)
          this.errors['selectedUseCase'] = 'Please select a use case';
        if (this.campaignDescription.length < 40)
          this.errors['campaignDescription'] =
            'Description must be at least 40 characters';
        if (this.messageSamples.length < 2)
          this.errors['messageSamples'] =
            'At least two message samples are required';
        else {
          this.messageSamples.forEach((sample, i) => {
            if (!sample || sample.length < 20)
              this.errors[`messageSamples${i}`] =
                'Must be at least 20 characters';
          });
        }
        if (this.messageFlow.length < 40)
          this.errors['messageFlow'] =
            'Message Flow must be at least 40 characters';
        isValid = Object.keys(this.errors).length === 0;
        break;
      case 8:
        if (!this.acceptTerms)
          this.errors['acceptTerms'] = 'You must accept the terms';
        isValid = Object.keys(this.errors).length === 0;
        break;
      default:
        isValid = false;
    }
    return isValid;
  }

  isFormValid(): boolean {
    return this.isStepValid() && this.currentStep === this.totalSteps;
  }

  getFormatExample(type: string): string {
    switch (type) {
      case 'CA:CBN':
        return '123456789 (9 digits)';
      case 'US:EIN':
        return '00-0000000';
      case 'US:DUNS':
        return '00-000-0000';
      default:
        return 'Check the required format';
    }
  }

  formatPhoneNumber(): string {
    let cleanNumber = this.repPhone.replace(/\D/g, '');
    if (
      cleanNumber.startsWith(this.selectedPhoneCountry.prefix.replace('+', ''))
    ) {
      cleanNumber = cleanNumber.slice(
        this.selectedPhoneCountry.prefix.length - 1
      );
    }
    return `${this.selectedPhoneCountry.prefix}${cleanNumber}`;
  }

  compareCountries(c1: { code: string }, c2: { code: string }) {
    return c1 && c2 ? c1.code === c2.code : c1 === c2;
  }
}

const formatRules: { [key: string]: RegExp } = {
  'CA:CBN': /^\d{9}$/,
  'US:EIN': /^\d{2}-\d{7}$/,
  'US:DUNS': /^\d{2}-\d{3}-\d{4}$/,
};
